import { render, staticRenderFns } from "./AdminWardsView.vue?vue&type=template&id=628fe5f8&scoped=true&"
import script from "./AdminWardsView.vue?vue&type=script&lang=js&"
export * from "./AdminWardsView.vue?vue&type=script&lang=js&"
import style0 from "./AdminWardsView.vue?vue&type=style&index=0&id=628fe5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fe5f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
